import { goToSignIn } from 'router/go-to';
import { shouldRenderMobileApp } from 'utils/detect-environment';
import { authAPI } from 'API/auth-api';

export const authLogout = (invalidateUser: () => void) => async () => {
    try {
        await authAPI.logout();
    } catch (e) {
        console.error(e);
    } finally {
        invalidateUser();
        goToSignIn({ forcePageReload: !shouldRenderMobileApp() });
    }
};

export const impersonateAuthLogout = (invalidateUser: () => void) => async () => {
    invalidateUser();
};
